var render = function render(){var _vm=this,_c=_vm._self._c;return _c('symbol',{attrs:{"id":`${_vm.prefix}draft-34`,"viewBox":"0 0 34 34"}},[_c('circle',{staticClass:"sign",attrs:{"cx":"17","cy":"17","r":"16","stroke-width":"2"}}),_c('circle',{staticClass:"sign",attrs:{"cx":"17","cy":"17","r":"8","stroke-width":"2","stroke-dasharray":"3.14 3.14"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }